'user strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.statistics_index', {
    url: 'statistics',
    template: '<statistics-index></statistics-index>'
  })
}



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/index/statistics_index.routes.js